import { DEFAULT_APP_LOCALE, isAppLocale, type AppLocale } from '@duvamarine/i18n/admin';
import { ar, enGB, ru, tr, type Locale as DateFnsLocale } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

/** date-fns locales for the calendars (month names, week start) per admin language. */
export const DATE_FNS_LOCALES: Record<AppLocale, DateFnsLocale> = { tr, en: enGB, ar, ru };

export const INTL_LOCALES: Record<AppLocale, string> = {
  tr: 'tr-TR',
  en: 'en-GB',
  ar: 'ar-u-nu-latn',
  ru: 'ru-RU',
};

export function useAppLocale(): AppLocale {
  const { i18n } = useTranslation();
  return isAppLocale(i18n.resolvedLanguage) ? i18n.resolvedLanguage : DEFAULT_APP_LOCALE;
}
